import { Navigate, useLocation } from "react-router-dom";
import AdminSettingsNav from "@/features/admin/components/AdminSettingsNav";
import { useIsAdmin } from "@/shared/hooks/useIsAdmin";

export default function AdminSettingsLayout({ children }: { children: React.ReactNode }) {
  const { isAdmin, loading } = useIsAdmin();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-full w-full items-center justify-center p-6 ds-body-sm text-muted-foreground">
        Checking access...
      </div>
    );
  }
  if (!isAdmin) {
    return <Navigate to="/settings/organization" replace state={{ from: location }} />;
  }

  return (
    <div className="flex h-full w-full flex-col overflow-hidden">
      <div className="shrink-0 bg-muted/40 px-4 py-4 md:px-6">
        <div className="mb-4 flex items-center gap-2">
          <h2 className="ds-title">Admin</h2>
          <span className="inline-flex items-center rounded-md bg-destructive/15 px-2 py-0.5 ds-micro-strong text-destructive">
            Restricted
          </span>
        </div>
        <AdminSettingsNav />
      </div>
      <div className="min-h-0 flex-1">{children}</div>
    </div>
  );
}
